<section class="inner-page">
  <div class="container tofupadding">
    <img src="assets/img/courtLogo.png" alt="logo" class="image-center">
    <h1 class="text-center">{{'TERMS_OF_USE_SYSTEM'|translate}}</h1>
    <div class="d-none d-md-block">
      <h1 class="text-center text-red">TERMS OF USE</h1>
      <h4 class="set-text margin-top-10">{{'TERMS_OF_USE_1'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_1_MESSAGE'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_2'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_3'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_4'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_5'|translate}}</h4>
      <h4 class="set-text">{{'TERMS_OF_USE_6'|translate}}</h4>
    </div>
    <div class="d-md-none">
      <h2 class="text-center text-red">TERMS OF USE</h2>
      <p class="set-text margin-top-10">{{'TERMS_OF_USE_1'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_1_MESSAGE'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_2'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_3'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_4'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_5'|translate}}</p>
      <p class="set-text">{{'TERMS_OF_USE_6'|translate}}</p>
    </div>
    <!-- <br> -->
    <hr style="    margin-left: 30%;
      margin-right: 30%;">

  </div>
</section>